<template>
    <v-dialog v-model="dialog" width="800px" class="pa-0 ma-0">
        <v-card>
            <v-card-title class="justify-center">Delete Conversation</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="py-3"><h2>This conversation will be deleted, this action can't be undone</h2></v-card-text>
            <v-divider></v-divider>
            <v-card-text>
                <v-row class="pa-2 ma-0">
                    <v-col cols=3 class="pa-2">Conversation id     </v-col><v-col cols=9 class="pa-2">{{ conversation.id }}</v-col>
                    <v-col cols=3 class="pa-2">Conversation created</v-col><v-col cols=9 class="pa-2">{{ conversation.created_date }}</v-col>
                    <v-col cols=3 class="pa-2">Assistant           </v-col><v-col cols=9 class="pa-2">{{ conversation.assistant_name }}</v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" small @click="deleteConversation">Comfirm Delete</v-btn>
                <v-btn color="primary" small @click="closeDialog">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    export default {
        components: {
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                conversation: {},
            }
        },
        methods: { 
            openDialog(conversation) {
                this.conversation = conversation;
                this.dialog = true;
            },
            closeDialog() {
                this.dialog = false;
            },
            deleteConversation() {
                this.$axios.post("ares/json/ares/syst/openai/deleteConversation.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "deleteConversation",
                    },
                    deleteConversation: {
                        conversation_id: this.conversation.id,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.deleteConversation.text,
                            color: res.data.deleteConversation.color,
                        });
                        this.$emit("updateData", "refresh");
                        this.closeDialog();
                    }
                });
            },
        }
    }
</script>